'use client'
import { Link } from '@/i18n/navigation'
import Card from '@mui/material/Card'

function CustomCard({ children, ...props }) {
  return (
    <Card
      component={Link}
      {...props}
      sx={{ display: 'block', ...(props.sx || {}) }}
    >
      {children}
    </Card>
  )
}

export default CustomCard
